import { Vue } from 'vue-class-component';
import { Media$Details } from '@/types/Media';
import { Prop } from '@Ravnur-Inc/decorators';

import './media-change-owner.scss';
import Lookup from '@/components/lookup/lookup';
import UsersRepository from '@/repositories/users-repository';
import { User, User$Compact } from '@/types/User';
import { showDoneNotification, showInfoNotification } from '@Ravnur-Inc/notifications/service';
import modalService from '@/helpers/modal.service';
import MediaRepository from '@/repositories/media-repository';

const CN = 'media-change-owner';

const repository = new UsersRepository();
const mediaRepository = new MediaRepository();

export default class MediaChangeOwner extends Vue {
  @Prop({ type: Object as () => Media$Details, required: true }) media: Media$Details;

  currentOwner: Nullable<User$Compact> = null;
  newOwner: Nullable<User> = null;
  showInput = false;

  render() {
    return (
      <div class={`${CN}`}>
        <div class={`${CN}__info`}>
          <l10n class={`${CN}__label`} group="media" tkey="field__owner" />
          <span class={`${CN}__name`}>{this.currentOwner?.displayName}</span>
          <r-button
            class={`${CN}__change`}
            color="primary"
            mode="borderless"
            onClick={() => (this.showInput = !this.showInput)}
          >
            <l10n group="common" tkey="action__change" />
          </r-button>
        </div>
        {this.showInput && (
          <div class={`${CN}__input-wrapper`}>
            <Lookup
              creator={false}
              data-testid="lookup"
              propName="displayName"
              repository={repository}
              v-slots={{
                option: ({ item }: { item: User }) => `${item.displayName} ${item.email}`,
              }}
              value={this.newOwner}
              onKeydown={() => (this.newOwner = null)}
              onSelect={(u: User) => (this.newOwner = u)}
            />
            <action-button
              class={`${CN}__submit`}
              color="primary"
              disabled={!this.newOwner}
              process={this.handleTransfer}
              size="sm"
            >
              <l10n group="common" tkey="action__submit" />
            </action-button>
          </div>
        )}
      </div>
    );
  }

  async handleTransfer() {
    if (!this.newOwner) {
      return;
    }

    const isSame = this.newOwner.id === this.media.owner.id;

    if (isSame) {
      showInfoNotification(this.$t('media', 'change-owner__same-user'));

      return;
    }

    const confirmation = await modalService
      .confirm(this.$t('media', 'change-owner__confirmation'), {
        confirmText: this.$t('media', 'change-owner__confirm-btn'),
      })
      .catch(() => false);

    if (!confirmation) {
      return;
    }

    try {
      await mediaRepository.transfer(
        this.newOwner.id,
        this.media.owner.id,
        [this.media.id],
        [],
        false
      );

      showDoneNotification(this.$t('media', 'change-owner__success'));

      this.currentOwner = this.newOwner;
      this.showInput = false;
      this.newOwner = null;
    } catch (e) {
      this.$processException(e);
    }
  }

  mounted() {
    this.currentOwner = this.media.owner;
  }
}
